module.exports = __webpack_public_path__ + "static/media/Icon_menu_recommend_rental.9a23f1f3.svg";